import React, { useEffect, useState } from 'react';
import { api, errText } from '@/lib/api';
import { Button } from '@/components/ui/button';
import { Sparkles, Loader2, CornerDownLeft } from 'lucide-react';
import { toast } from 'sonner';
import { AiMeta } from '@/components/ai/AiCommon';

export const AiSuggestBox = ({ ticketId, onUse }) => {
  const [sug, setSug] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setSug(null);
    if (!ticketId) return;
    api.get('/ai/suggestions', { params: { ticket_id: ticketId, status: 'draft', limit: 1 } })
      .then(({ data }) => setSug(data?.[0] || null)).catch(() => {});
  }, [ticketId]);

  const suggest = async () => {
    setLoading(true);
    try {
      const { data } = await api.post(`/tickets/${ticketId}/ai-suggest`);
      setSug(data);
      toast.success('Sugerencia de IA lista');
    } catch (e) { toast.error(errText(e)); } finally { setLoading(false); }
  };

  return (
    <div className="rounded-lg border border-[hsl(var(--primary))]/30 bg-[hsl(var(--primary))]/5 p-3 space-y-3" data-testid="ai-suggest-box">
      <div className="flex items-center justify-between gap-2">
        <span className="text-sm font-medium flex items-center gap-1.5"><Sparkles className="w-4 h-4 text-[hsl(var(--primary))]" />Asistente IA</span>
        <Button size="sm" variant="outline" onClick={suggest} disabled={loading} data-testid="ai-suggest-btn">
          {loading ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Sparkles className="w-4 h-4 mr-2" />}
          {sug ? 'Regenerar' : 'Sugerir con IA'}
        </Button>
      </div>
      {sug && (
        <>
          <AiMeta result={sug} />
          <div className="text-sm whitespace-pre-wrap rounded-md bg-[hsl(var(--background))]/60 border border-border p-3" data-testid="ai-suggest-reply">{sug.reply}</div>
          <div className="flex justify-end">
            <Button size="sm" onClick={() => onUse(sug)} data-testid="ai-use-draft"><CornerDownLeft className="w-4 h-4 mr-2" />Usar borrador</Button>
          </div>
        </>
      )}
    </div>
  );
};
